const my_profile = {
  viewMyClubSeacretProfile: "내 ClubSeacret 프로필 보기", // translated 
  viewMoreDetails: "자세한 내용을 보려면 클릭하세요.", // translated 
  verifiedEmail: "인증된 이메일", // translated 
  unverifiedEmail: "확인되지 않은 이메일", // translated 
  balance: "균형", // translated 
  pointsIn: "포인트 인", // translated 
  pointsOut: "지적하다", // translated 
  topUp: "충전", // translated 
  pointsHistoryTable: "포인트 기록표", // translated 
  createdFrom: "~에서 생성됨", // translated 
  createdTo: "만들어지다", // translated 
  selectStatus: "상태를 선택하세요...", // translated 
  searchByTitle: "제목으로 검색...", // translated 
  offerStatus: "제안 상태", // translated 
  selectOfferStatus: "모두", // translated 
  quotationSent: "견적서 발송 완료", // translated 
  offerInProgress: "제안 진행 중", // translated 
  offerAvailable: "할인 혜택 제공", // translated 
  offerAccepted: "제안 수락됨", // translated 
  offerExpired: "이벤트 종료", // translated 
  offerReference: "제안 참조", // translated 
  tripStartDate: "여행 시작일", // translated 
  dueDate: "마감일", // translated 
  viewOffer: "제안 보기", // translated 
  notApplicable: "해당 없음", // translated 
  manageSubscription: "구독 관리", // translated 
  logoAndColors: "로고 및 색상", // translated 
  editColors: "색상 편집", // translated 
  editLogo: "로고 편집", // translated 
  primaryColor: "원색", // translated 
  secondaryColor: "보조 색상", // translated 
  subagentLogoAlt: "하위 에이전트 로고", // translated 
  pickColors: "색상을 선택하세요", // translated 
  logoPreview: "로고 미리보기", // translated 
  logoPreviewAlt: "로고 미리보기", // translated 
  noLogoSelected: "로고가 선택되지 않았습니다.", // translated 
  changeLogo: "로고 변경", // translated 
  uploadLogo: "로고 업로드", // translated 
  supportedImageFormats: "지원 파일 형식: JPG, PNG. 최대 크기: 2MB", // translated 
  saving: "절약...", // translated 
  logoUpdatedSuccess: "로고 업데이트가 완료되었습니다.", // translated 
  failedToUpdateLogo: "로고 업데이트에 실패했습니다", // translated 
  colorsUpdatedSuccess: "색상이 성공적으로 업데이트되었습니다.", // translated 
  failedToUpdateColors: "색상 업데이트에 실패했습니다.", // translated 
  selectImageFile: "이미지 파일을 선택해 주세요.", // translated 
  imageSizeLimit: "이미지 크기는 5MB 미만이어야 합니다.", // translated 
  pushNotifications: "푸시 알림", // translated 
  pushNotificationsDescription: "중요 업데이트 및 이벤트에 대한 브라우저 알림을 받으세요.", // translated 
  pushNotificationsNotSupported: "이 브라우저에서는 푸시 알림이 지원되지 않습니다.", // translated 
  pushNotificationsDeniedMessage: "알림 권한이 거부되었습니다. 푸시 알림을 받으려면 브라우저 설정에서 알림을 활성화하세요.", // translated 
  pushNotificationsEnabled: "푸시 알림이 성공적으로 활성화되었습니다.", // translated 
  pushNotificationsDisabled: "푸시 알림이 성공적으로 비활성화되었습니다.", // translated 
  userInformationMissing: "사용자 정보가 누락되었습니다.", // translated 
  failedToUpdatePushNotifications: "푸시 알림 설정 업데이트에 실패했습니다.", // translated 
  notificationPermissionDenied: "알림 권한이 거부되었습니다. 브라우저 설정에서 알림 권한을 활성화해 주세요.", // translated 
  notificationPermissionRequired: "푸시 알림을 활성화하려면 알림 권한이 필요합니다.", // translated 
  notSupported: "지원되지 않음", // translated 
  permissionDenied: "권한이 거부되었습니다", // translated 
  permissionNotRequested: "권한 요청 안 함", // translated 
  enabled: "활성화됨", // translated 
  disabled: "장애가 있는", // translated 
};


export default my_profile;
